import { render, staticRenderFns } from "./ManageData.vue?vue&type=template&id=f312bfe2&scoped=true"
import script from "./ManageData.vue?vue&type=script&lang=js"
export * from "./ManageData.vue?vue&type=script&lang=js"
import style0 from "./ManageData.vue?vue&type=style&index=0&id=f312bfe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f312bfe2",
  null
  
)

export default component.exports